import Layout from '../components/Layout';
import FormPedido from '../components/formPedido';


const NuevoPedido = () => {

	return (
		<Layout
			pagina={"Mi compra"}
		>
			<div className='w-full pt-20 pb-20'>
				<FormPedido />
			</div>
		</Layout>
	)
}

export default NuevoPedido